import * as autoBind from "auto-bind";
import * as React from "react";
import { Link } from "react-router-dom";

import LoadObject from "../../load_objects/LoadObject";
import { ILogin } from "../records/Login";
import "../login.css";

export interface ILoginViewProps
{
    loginLoader: LoadObject<ILogin>;
    onLogin: (username: string, password: string) => void;
    logout: () => void;
}

export interface ILoginViewState
{
    username: string;
    pwd: string;
}

export class LoginView extends React.PureComponent<ILoginViewProps, ILoginViewState>
{
    constructor(props: any)
    {
        super(props);
        autoBind.react(this);

        this.state = {
            username: "",
            pwd: ""
        };
    }

    public componentWillReceiveProps(newProps)
    {
        if (newProps.loginLoader.hasError())
        {
            this.showAlertBox("Incorrect username or password");
        }
    }

    public render()
    {
        const username = this.state.username;
        const pwd = this.state.pwd;

        return (
            <div className="loginBox">
                <section className={"loginWrap"}>
                    <h2 className="loginHead">Account Login</h2>

                    <section className="inputWrapper">
                        <label className="inputLabel">Username</label>
                        <input
                            className="inputField"
                            type="text"
                            onKeyPress={this.handleKeyPress}
                            onChange={this.onUsernameChanged}
                            value={username} />
                    </section>

                    <section className="inputWrapper">
                        <label className="inputLabel">Password</label>
                        <input
                            className="inputField"
                            type="password"
                            onKeyPress={this.handleKeyPress}
                            onChange={this.onPwdChanged}
                            value={pwd} />
                    </section>

                    <section className="alertBox hidden" id="alertBox"></section>

                    <section className="inputWrapper">
                        <button className="loginButton" onClick={this.doLogin}>Log in</button>
                    </section>
                    
                    {/*<section className="signUp-linker"> Or <Link to="/signup" className="href">sign up</Link></section>*/}

                    <section className="contactInfo">
                        Forgot username or password?
                        Please contact us at <a href="mailto:support@gamescorekeeper.com" className="href">support@gamescorekeeper.com</a>
                    </section>
                </section>
            </div>
        );
    }

    private onStateChanged(changes)
    {
        const newState = {
            username: changes.username || this.state.username,
            pwd: changes.pwd || this.state.pwd
        };

        if (changes.username === "")
        {
            newState.username = "";
        }
        if (changes.pwd === "")
        {
            newState.pwd = "";
        }

        this.setState(newState);
    }

    private doLogin()
    {
        const username = this.state.username;
        const password = this.state.pwd;

        if (!username)
        {
            this.showAlertBox("Please enter a username");
        }
        else if (!password)
        {
            this.showAlertBox("Please enter a password");
        }
        else
        {
            this.hideAlertBox();
        }

        this.props.onLogin(username, password);
    }

    private showAlertBox(warning)
    {
        const alertBox = document.getElementById("alertBox")!;
        alertBox.innerHTML = warning;
        alertBox.classList.remove("hidden");
    }

    private hideAlertBox()
    {
        const alertBox = document.getElementById("alertBox")!;
        alertBox.classList.add("hidden");
    }

    private onUsernameChanged(evt)
    {
        this.onStateChanged({ username: evt.target.value });
    }

    private onPwdChanged(evt)
    {
        this.onStateChanged({ pwd: evt.target.value });
    }

    private handleKeyPress(evt)
    {
        if (evt.charCode === 13)
        {
            this.doLogin();
            return true;
        }

        return false;
    }
}
